import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions";
import { getContactName } from "@/lib/utilities/helpers/contact";
import { arrayToObj } from "@/lib/utilities";
import Vue from "vue";

function sortResultsByName(results) {
  if (!results || results.length == 0) return [];

  return results.sort((result1, result2) => {
    return result1.name &&
      result2.name &&
      result1.name.toLowerCase() > result2.name.toLowerCase()
      ? 1
      : -1;
  });
}

const state = {
  LogCallResults: [],
  LogNoteResults: [],
  FilterTypes: [],
  RuleGroupTypes: [],
  RuleReseedStatus: [],
  Countries: [],
  StateProvinces: [],
  LookupEnums: {},
  TouchpointResultReasons: [],
  IsTouchpointResultReasonsActivated: false,
  TouchpointResults: [],
  TemplateCategories : []
};

const getters = {
  StateProvinces: state => state.StateProvinces,
  FilterTypes: function(state) {
    return state.FilterTypes;
  },
  Enums: function(state) {
    return state.LookupEnums || {};
  },
  getContactName: (state, getters) => contact => {
    return getContactName(contact, getters.Enums);
  },
  NoteTypesMappedByName: function(state) {
    return state.LookupEnums && state.LookupEnums.note_type
      ? arrayToObj(state.LookupEnums.note_type, "name")
      : null;
  },
  PhoneTypesMappedByName: function(state) {
    return state.LookupEnums && state.LookupEnums.phone_type
      ? arrayToObj(state.LookupEnums.phone_type, "name")
      : null;
  }
};

const actions = {
  getSoldByNames(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/crm/lookup/sold_by_name",
          request.accountPlatformIds
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },

  getLogCallResults(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/lookup/action_results/log_call")
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotLogCallResults", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getLogNoteResults(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/lookup/action_results/log_note")
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotLogNoteResults", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getFilterTypes: function(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/Lookup/filterType")
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotFilterTypes", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getRuleGroupTypes(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/lookup/rulegrouptype")
        .then(resp => {
          if (resp.data && resp.data.data) {
            context.commit("gotRuleGroupTypes", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getRuleReseedStatus(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/lookup/rulereseedstatus")
        .then(resp => {
          if (resp.data && resp.data.data) {
            context.commit("gotRuleReseedStatus", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },

  getCountries(context) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest("get", "/crm/Lookup/countries")
          .then(response => {
            if (response && response.data.successful) {
              context.commit("setCountries", response.data.data);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => reject(error))
      );
    });
  },
  getStateProvinces(context, countryid) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/crm/Lookup/countries/" + countryid + "/state_provinces"
          )
          .then(response => {
            if (response && response.data.successful) {
              context.commit("setStateProvinces", response.data.data);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => reject(error))
      );
    });
  },
  getLookupEnums(context) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest("get", "/crm/Lookup/enums")
          .then(response => {
            if (response && response.data.successful) {
              context.commit("setEnums", response.data.data);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => reject(error))
      );
    });
  },
  async getTemplateCategoryEnums(context){
    let response = await Vue.http
    .get("templatemanager/gettemplatelookups");

    if(response && response.data)
    {
      context.commit("updateTemplateCategories", response.data.Data ? response.data.Data : []);
      return response.data.Data;
    }
    else
    context.commit("updateTemplateCategories",[]);
  },
  getTouchpointResultsEnum(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/Lookup/touchpoint_result")
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotTouchpointResultsEnum", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getTouchpointResultReasonsEnum(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/crm/Lookup/touchpoint_result_reason")
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotTouchpointResultReasonsEnum", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getMakesByYears(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/crm/Lookup/vehicle/makes", request)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getModelsByYearsAndMakes(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/crm/Lookup/vehicle/models", request)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp.data.data ? resp.data.data : []);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getTrimsByModels: function(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/crm/Lookup/vehicle/trims", request)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(
              resp.data.data
                ? resp.data.data.sort(
                    HelperFunctions.sortByPropertyAsc("vehicleTrimName")
                  )
                : []
            );
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchRecallsLite(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/recalls/lite",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchDealerBanks(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/bank/dealer_banks",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
};

const mutations = {
  setCountries(state, val) {
    state.Countries = val;
  },
  setStateProvinces(state, val) {
    state.StateProvinces = state.StateProvinces.concat(val);
  },
  setEnums(state, val) {
    if (val && val.crm_lead_type && val.crm_lead_type.length > 0) {
      let types = val.crm_lead_type;
      let categories = val.crm_lead_category;
      types.forEach(type => {
        let category = categories.find(x => x.id == type.crmLeadCategoryId);
        type.name = category
          ? type.name + " (" + category.name + ")"
          : type.name;
      });
    }
    state.LookupEnums = val;
  },
  gotLogCallResults(state, data) {
    state.LogCallResults = sortResultsByName(data);
  },
  gotLogNoteResults(state, data) {
    state.LogNoteResults = sortResultsByName(data);
  },
  gotFilterTypes(state, data) {
    state.FilterTypes = sortResultsByName(data);
  },
  gotRuleGroupTypes(state, data) {
    state.RuleGroupTypes = sortResultsByName(data);
  },
  gotRuleReseedStatus(state, data) {
    state.RuleReseedStatus = sortResultsByName(data);
  },
  gotTouchpointResultsEnum(state, data) {
    state.TouchpointResults = sortResultsByName(data);
  },
  gotTouchpointResultReasonsEnum(state, data) {
    state.TouchpointResultReasons = sortResultsByName(data);
    state.IsTouchpointResultReasonsActivated = true;
  },
  updateTemplateCategories(state, data){
    state.TemplateCategories = data && data.Categories ? data.Categories : [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/LookUp.js